import { Address, PdqUser } from '@pdqdev/pdq-shared/dist/entities';
import { Carrier } from '@app/services/carriers/carrier.model';
import { BatchFilterOptions, BatchFilterOption } from '@app/sharedModule/models/paginated-batch-table.model';

export interface UserLocation {
  locationId?: string | number;
}

export function createLocationFilterOptions(
  shopLocations: Address[],
  userLocations?: UserLocation[],
): BatchFilterOptions {
  const userLocationIds = userLocations?.map((loc) => loc.locationId).filter((id) => id != null);
  const shopLocationOptions: BatchFilterOption[] = shopLocations
    .filter((location) => !userLocationIds?.length || userLocationIds.some((id) => id === location.id))
    .map((location) => ({
      active: false,
      value: location.id,
      label: location.storeName,
    }));

  return {
    displayName: 'Location',
    active: false,
    options: [{ active: false, value: null, label: 'All' }, ...shopLocationOptions],
  };
}

export function createOwnerFilterOptions(users: PdqUser[]): BatchFilterOptions {
  const ownerOptions: BatchFilterOption[] = users.map((user) => ({
    active: false,
    value: user.email,
    label: user.name,
    img: {
      path: user.profilePictureUrl,
      class: 'avatar',
    },
  }));

  return {
    displayName: 'Owner',
    active: false,
    options: [{ active: false, value: null, label: 'All' }, ...ownerOptions],
  };
}

export function createCarrierFilterOptions(carriers: Carrier[]): BatchFilterOptions {
  const carrierOptions: BatchFilterOption[] =
    carriers?.map((carrier) => ({
      active: false,
      value: carrier.id,
      label: carrier.name,
    })) ?? [];

  return {
    displayName: 'Carrier',
    active: false,
    options: [{ active: false, value: null, label: 'All' }, ...carrierOptions],
  };
}

export function createEmptyFilterOptions(displayName: string): BatchFilterOptions {
  return {
    displayName,
    active: false,
    options: [{ active: false, value: null, label: 'All' }],
  };
}
